export default "__VITE_ASSET__BAe47R1q__"